var map = {
	"./character/informa.svg": "x31t",
	"./character/oops.svg": "vlLt",
	"./character/sorprendido.svg": "+tJy",
	"./cobertura-fallecimiento.png": "AzqN",
	"./cobertura-gastos-medicos.png": "w/hs",
	"./cobertura-gastos-sepelio.png": "yZ+T",
	"./cobertura-incapacidad-temporal.png": "7XRZ",
	"./cobertura-invalidez.png": "DGs/",
	"./consultar-siniestro.png": "m7Jo",
	"./demo-smartphone.svg": "UQQ8",
	"./icono-desgravamen.png": "LdGA",
	"./icono-otros.png": "ezXR",
	"./icono-proteccion-financiera.png": "HX65",
	"./icono-proteccion-tarjeta.png": "IEl6",
	"./icono-renta-hospitalaria.png": "NIEq",
	"./icono-seguro-de-vida.png": "oS92",
	"./icono-soat.png": "Cz5r",
	"./icono-vehicular.png": "mEWX",
	"./icono-vida-ley.png": "HwH8",
	"./registrar-siniestro.png": "4YWE",
	"./siniestros-banner-mobile.png": "3hZo",
	"./siniestros-banner.png": "z9KH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 1